export const AUTH_ROUTE_ID = 'authenticated' as const;
